import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import ReviewSliderBtn from '../../../components/ReviewSliderBtn';

const Wrapper = styled.section`
  background: var(--secoundary-secoundary-400, #D443A0);
  
  .container{
    max-width: 1440px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    padding: ${({ onboarding }) => (onboarding ? '0 2rem' : '0 6.25rem')};
  }

  .testimonial-btn{
    position: absolute;
    display: flex;
    transform: rotate(8.522deg);
    padding: 6px 12px;
    color: var(--secoundary-secoundary-500-f, #CB1D8D);
    border: none;
    font-family: Instrument Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    top: 17%;
    left: 6%;
  }

  .testimonial{
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1.5rem;
    padding: 6.25rem 0;

    h2{
      color: var(--font-color-font-4, #FFF);
      font-family: Instrument Sans;
      font-size: 64px;
      font-style: normal;
      font-weight: 700;
      line-height: 88px;
    }

    p{
      color: var(--font-color-font-4, #FFF);
      font-family: Instrument Sans;
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: 28px;
      margin: 0px;
    } 
  }

  .slider{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;
    height: 800px;
    
    .line {
      background: white;
      height: 100%;
      width: 2px;
      position: absolute;
    }

    .sliderBtn{
      background-color: #D443A0;
      cursor: pointer;
      z-index: 1;
    }
  }

  .card-container-outer{
   margin: 3rem 0;
   margin: ${({ onboarding }) => (onboarding ? '0' : '3rem 0')};
   overflow: scroll;
   width: 50%;
   
   .card-container{
      max-height: ${({ onboarding }) => (onboarding ? '100vh' : '940px')};
      
      overflow: auto;

    //   .grid-item{
    //   max-height : 500px;
    //   }

      //  .grid-item{
      //   :nth-child(even){
      //     position: relative;
      //     top: 45%;
      //   }
      // }

      -ms-overflow-style: none;
      scrollbar-width: none;

      ::-webkit-scrollbar { 
        display: none;
      }
    }

    -ms-overflow-style: none;
    scrollbar-width: none;

    ::-webkit-scrollbar { 
      display: none;
    }
  }

@media screen and (max-width: 1024px){
  .container{
    padding: ${({ onboarding }) => (onboarding ? '0 1rem' : '0 3.25rem')};
  }

  .testimonial-btn{
    top: 17%;
    left: 4%;
  }

  .testimonial{
    h2{
      font-size: 45px;
      line-height: 58px;
    }

    p{
      font-size: 18px;
      line-height: 28px;
    } 
  }

  .slider{
    height: 600px;
  }

  .card-container-outer{
   margin: 3rem 0;
   overflow: scroll;
   width: 50%;
   
   .card-container{
      max-height: 740px;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-auto-rows: auto;
      gap: 10px;
      overflow: auto;

      // .grid-item{
      //   :nth-child(even){
      //     position: relative;
      //     top: 45%;
      //   }
      }

      -ms-overflow-style: none;
    scrollbar-width: none;

    ::-webkit-scrollbar { 
      display: none;
    }
    }

    -ms-overflow-style: none;
    scrollbar-width: none;

    ::-webkit-scrollbar { 
      display: none;
    }
  }
}

@media screen and (max-width: 768px) {
  .container{
    flex-direction: column;
    gap: 1rem;
    padding: 4rem 0rem 2rem 0rem;
    overflow: hidden;
  }

  .testimonial-btn{
    padding: 4px 8px;
    font-size: 12px;
    line-height: 20px;
    top: 2%;
    left: 3%;
  }
  
  .testimonial{
    align-items: center;
    padding: 0rem 1.25rem;
    width: 100%;

    h2{
      font-size: 32px;
      line-height: 40px;
      width: 80%;
      text-align: center;

    }

    p{
      font-size: 16px;
      line-height: 24px;
      margin: 0px;
      text-align: center;

    }
  }

  .slider{
    margin: 0rem 1.25rem;
    flex-direction: row;
    height: auto;
    width: 90%;
    
    .line {
      height: 2px;
      width: 100%;
    }

    .sliderBtn{
      background-color: #D443A0;
      cursor: pointer;
      z-index: 1;
    }
  }

  .card-container-outer{
    margin: 1.5rem 0;
    width: 100%;
    
    .card-container{
      display: flex;
      gap: 1rem;
      overflow: scroll;
      padding: 0 1.25rem;
 
        .grid-item{
          width: 250px;
          flex-shrink: 0;
          
          :nth-child(even){
            position: static;
            top: 45%;
          }
        }

        -ms-overflow-style: none;
        scrollbar-width: none;
    
        ::-webkit-scrollbar { 
          display: none;
        }
      }
    }
  }
}
`;

const Card = styled.div`
  flex-direction: column;
  border-radius: 16px;
  border: 1.5px solid var(--font-color-font-2, #666467);
  background: var(--white-shades-white-100, #fff);
  margin-bottom: 5px;

  img {
    // height: 100%;
  }

  .img-div {
    border-radius: 16px;
    overflow: hidden;
  }

  .content {
    display: flex;
    padding: 1.25rem 1rem 1rem 1rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;

    h3 {
      color: var(--font-color-font-1, #1b131f);
      font-family: Instrument Sans;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 26px;
      white-space: nowrap;
      overflow: hidden;
      max-width: 100%;
      text-overflow: ellipsis;
    }

    p {
      font-family: Instrument Sans;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
    }

    .category {
      color: var(--font-color-font-3, #b4b2b5);
    }

    .description {
      color: var(--font-color-font-2, #666467);
      max-height: 50px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .price {
      color: var(--primary-primary-600-f, #62aa48);
      text-align: center;
      font-family: Instrument Sans;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: 32px;
    }
  }
`;

const FaceBook = () => {
  const [data, setData] = useState({});
  const [activeIndex, setActiveIndex] = useState(0);
  const [indexValue, setIndexValue] = useState(null);
  const [firstHalf, setFirstHalf] = useState([]);
  const [secondHalf, setSecondHalf] = useState([]);

  const toggleReadMore = (index) => {
    if (index == indexValue) {
      setIndexValue(null);
    } else {
      setIndexValue(index);
    }
  };

  useEffect(() => {
    const accessToken =
      'EAAHCvrnIg8kBO5AL7k28al68C1bxsOWo9fq0L90acGR0EIEXnaM6kA17SZA5A6GNcEWYc85Y9EkBDZCsTevOxySqC17ZAjDpDZBAwYgBDeKThgHajWUWta9ltF3OWELLZCVd9ZBY79ZB8AnlcFdOkIJ8LKFT3ppYjTG5QCX5Gmvg3UAZAZAZAP7vcKFYJdVMDIzJelzH2NqHrQGg01dnkZD';
    const pageId = '255298144333371';

    const fetchData = async () => {
      const response = await axios.get(
        `https://graph.facebook.com/v20.0/${pageId}?fields=id,name,about,description,fan_count,link,posts{message,created_time,attachments{media},likes.summary(true), comments.summary(true), permalink_url},followers_count&access_token=${accessToken}`,
      );
      setData(response.data);
      const half = Math.floor(response?.data?.posts?.data?.length / 2);
      setFirstHalf(response?.data?.posts?.data.slice(0, half));
      setSecondHalf(
        response?.data?.posts?.data.slice(
          half,
          response?.data?.posts?.data.length,
        ),
      );
    };

    fetchData();
  }, []);

  const formatText = (text) => {
    if (typeof text !== 'string') {
      return '';
    }
    return text.replace(/\n\n/g, '<br /><br />');
  };

  const containerRef = useRef(null);
  const containerOuterRef = useRef(null);
  const [scrolling, setScrolling] = useState(true);
  const scrollSpeed = 2;

  useEffect(() => {
    const container = containerRef.current;
    const containerOuter = containerOuterRef.current;

    const resetScrollToTop = () => {
      const containerHeight = container.scrollHeight;
      const containerWidth = container.scrollWidth;
      const visibleHeight = container.clientHeight;
      const visibleWidth = container.clientWidth;

      if (container.scrollTop + visibleHeight >= containerHeight) {
        container.scrollTop = 0;
      }

      if (container.scrollLeft + visibleWidth >= containerWidth) {
        container.scrollLeft = 0;
      }
    };

    const scrollContainer = () => {
      container.scrollTop += scrollSpeed;
      container.scrollLeft += scrollSpeed;
      resetScrollToTop();
    };

    let scrollInterval;
    if (scrolling) {
      scrollInterval = setInterval(scrollContainer, 30); // Adjust the interval as needed
    }

    return () => {
      clearInterval(scrollInterval);
    };
  }, [scrolling]);

  useEffect(() => {
    const handleMouseEnter = () => setScrolling(false);
    const handleMouseLeave = () => setScrolling(true);

    const containerOuter = containerOuterRef.current;
    containerOuter.addEventListener('mouseenter', handleMouseEnter);
    containerOuter.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      containerOuter.removeEventListener('mouseenter', handleMouseEnter);
      containerOuter.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);


  return (
    <Wrapper
      onboarding={false}
      style={{ marginTop: '6rem', marginBottom: '6rem' }}
    >
      <div className="container">
        <div className="testimonial">
          <h2>
            <a
              style={{ color: 'white' }}
              className="pointer"
              href={data?.link}
              target="_blank"
            >
              Follow us on Facebook !
            </a>
          </h2>
          <p
            className="pointer"
            dangerouslySetInnerHTML={{ __html: formatText(data?.about) }}
          />
          <div className="d-flex flex-row">
            <span className="d-flex flex-row">
              <p>{data?.fan_count}</p>
              <p className="mx-1">{data?.fan_count <= 1 ? 'Like' : 'Likes'}</p>
            </span>
            <span className="d-flex flex-row mx-4">
              <p>{data?.followers_count}</p>
              <p className="mx-1">
                {data?.followers_count <= 1 ? 'Comment' : 'Comments'}
              </p>
            </span>
          </div>
        </div>

        <div className="card-container-outer" ref={containerOuterRef}>
          <div
            style={{
              position: 'relative',
              display: 'flex',
              flexDirection: 'row',
              gap: '10px',
            }}
            className="card-container"
            ref={containerRef}
          >
            <div style={{ width: `calc(50% - 5px)` }}>
              {secondHalf.map((item, index) => (
                <div className="grid-item mb-2" key={index}>
                  <Card>
                    {item?.attachments?.data[0]?.media?.image?.src && (
                      <div className="img-div">
                        <a href={item?.permalink_url} target="_blank">
                          <img
                            style={{
                              minHeight: 270,
                              width: '100%',
                              objectFit: 'contain',
                            }}
                            src={item?.attachments?.data[0]?.media?.image?.src}
                            loading="lazy"
                            //   alt={imgAlt}
                          />
                        </a>
                      </div>
                    )}
                    <div className="content">
                      <div>
                        {item?.message && (
                          <>
                            <a href={item?.permalink_url} target="_blank">
                              <p
                                style={{
                                  maxHeight:
                                    item?.id == indexValue ? '5000px' : '150px',
                                }}
                                className="description"
                                dangerouslySetInnerHTML={{
                                  __html: formatText(item?.message),
                                }}
                              />
                            </a>
                            <span
                                className="read-more"
                                onClick={() => toggleReadMore(item?.id)}
                              >
                                {item?.id == indexValue
                                  ? 'Read Less'
                                  : 'Read More'}
                              </span>
                          </>
                        )}
                      </div>
                      <div className="d-flex justify-content-between w-100">
                        <span className="d-flex flex-row">
                          <p>{item?.likes.summary.total_count}</p>
                          <p className="mx-1">
                            {item?.likes.summary.total_count <= 1
                              ? 'Like'
                              : 'Likes'}
                          </p>
                        </span>
                        <span className="d-flex flex-row">
                          <p>{item?.comments.summary.total_count}</p>
                          <p className="mx-1">
                            {item?.comments.summary.total_count <= 1
                              ? 'Comment'
                              : 'Comments'}
                          </p>
                        </span>
                      </div>
                    </div>
                  </Card>
                </div>
              ))}
            </div>
            <div
              style={{
                width: `calc(50% - 5px)`,
                position: 'absolute',
                top: '20%',
                right: 0,
              }}
            >
              {firstHalf.map((item, index) => (
                <div className="grid-item mb-2" key={index}>
                  <Card>
                    {item?.attachments?.data[0]?.media?.image?.src && (
                      <div className="img-div">
                        <a href={item?.permalink_url} target="_blank">
                          <img
                            style={{
                              minHeight: 270,
                              width: '100%',
                              objectFit: 'contain',
                            }}
                            src={item?.attachments?.data[0]?.media?.image?.src}
                            loading="lazy"
                            //   alt={imgAlt}
                          />
                        </a>
                      </div>
                    )}

                    <div className="content">
                      <div>
                        {item?.message && (
                          <>
                            <a href={item?.permalink_url} target="_blank">
                              <p
                                style={{
                                  maxHeight:
                                    item?.id == indexValue ? '5000px' : '150px',
                                }}
                                className="description"
                                dangerouslySetInnerHTML={{
                                  __html: formatText(item?.message),
                                }}
                              />
                            </a>
                            <span
                              className="read-more"
                              onClick={() => toggleReadMore(item?.id)}
                            >
                              {index == indexValue ? 'Read Less' : 'Read More'}
                            </span>
                          </>
                        )}
                      </div>
                      <div className="d-flex justify-content-between w-100">
                        <span className="d-flex flex-row">
                          <p>{item?.likes.summary.total_count}</p>
                          <p className="mx-1">
                            {item?.likes.summary.total_count <= 1
                              ? 'Like'
                              : 'Likes'}
                          </p>
                        </span>
                        <span className="d-flex flex-row">
                          <p>{item?.comments.summary.total_count}</p>
                          <p className="mx-1">
                            {item?.comments.summary.total_count <= 1
                              ? 'Comment'
                              : 'Comments'}
                          </p>
                        </span>
                      </div>
                    </div>
                  </Card>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default FaceBook;
